import { queryKeys } from "../queryKeys";
import { type Clock, getClock } from "../rest/data";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetClock = ({
  options,
}: {
  options?: QueryOptions<Clock>;
} = {}) => {
  const { data: clock } = useRequest(queryKeys.clock(), () => getClock(), {
    ...options,
  });

  return { clock };
};

export default useGetClock;
